import * as React from 'react';

import './index.scss'

const SkillCreator = ({ projectData }) => {
    let {
        tech,
    } = projectData

  return tech.map((skill, index) => {
    return (
      <div key={'skill' + index} className="project-tech-skill">
        {skill}
      </div>
    );
  });
};

export default SkillCreator;